<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="'New Class'" :directory="$t('transaction')" :icon="'grid'"/>
            </div>
            <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <button type="button"
                            class="btn btn-success btn-with-shadow"
                            @click="exportAll">
                        {{ $t('export_all') }}
                    </button>
                    <button type="button"
                            class="btn btn-primary btn-with-shadow"
                            data-toggle="modal"
                            @click="openAddEditModal">
                        {{ $t('add') }}
                    </button>
                </div>
            </div>
        </div>

        <app-table
            :id="tableId"
            :options="options"
            @action="getListAction"
        />

        <modal-form
            v-if="isAddEditModalActive"
            :table-id="tableId"
            :form-id="formId"
            v-model="rowData"
            :selected-url="selectedUrl"
            @close-modal="closeAddEditModal"
        />

        <modal-form-continue
            v-if="isEditContinueModalActive"
            :table-id="tableId"
            :form-id="formIdContinue"
            v-model="rowData"
            :selected-url="selectedUrl"
            @close-modal="closeEditContinueModal"
        />

        <app-delete-modal
            v-if="deleteConfirmationModalActive"
            :preloader="deleteLoader"
            modal-id="demo-delete"
            @confirmed="onDelete"
            @cancelled="onCancelDelete"
        />
    </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import {Schema} from './Schema';
import {urlGenerator} from "../../../../Helpers/AxiosHelper";

export default {
    extends: CoreLibrary,
    name: "NewCourse",
    mixins: [Schema],
    created() {
        this.options.columns = [...this.tableColumns];
        // this.searchAndSelectFilterOptions();
    },
	mounted() {
		
		window.Handlecontinue = (id,course_name) => {
			this.openContinue(id,course_name);
		};
		window.Handleedit = (id) => {
			this.openEdit(id);
		};
		window.Handledelete = (id) => {
			this.openDelete(id);
		};
    },
    methods: {
        /**
         * for open add edit modal
         */
        openContinue(id,course_name){
            Swal.fire({
                title: 'Confirmation',
                html: `Continue Class ${course_name} `,
                icon: 'question',
                showCancelButton: true,
                showDenyButton: true,
                confirmButtonText: 'Continue',
                denyButtonText: 'Edit',
                cancelButtonText: 'Cancel',
                denyButtonColor: '#46c35f',
                }).then((result) => {
                if (result.isConfirmed) {
                    
                    Swal.fire({
                        title: "",
                        text: "Are you sure you want to confirm this class for the next semester?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Ok",
                        cancelButtonText: "Cancel",
                        reverseButtons: true,
                    }).then((result) => {
                        if (result.isConfirmed) {

                            Swal.close();

                            Swal.fire({
                                title: 'Processing...',
                                allowOutsideClick: false,
                                showConfirmButton: false,
                                didOpen: () => Swal.showLoading()
                            });

                            this.axiosPatch({
                                url: `/transaction/new-course-continue-next-semester/${id}`,
                            })
                            .then((response) => {
                                Swal.close();

                                if (response.data.status === true) {
                                    Swal.fire({
                                        title: "Success",
                                        text: "Class successfully continued to the next semester.",
                                        icon: "success",
                                    }).then(() => {
                                        this.reloadTable();
                                    });
                                } else {
                               
                                    Swal.fire({
                                        title: "Failed",
                                        text: response.data.message,
                                        icon: "error",
                                    });
                                }
                            })
                            .catch((error) => {
                                Swal.close();

                                const message = error.response?.data?.message || error.message || "Something went wrong";

                                Swal.fire({
                                    title: "Failed",
                                    text: message,
                                    icon: "error",
                                });
                            });
                        }
                    });
                    
                } else if (result.isDenied) {

                    this.selectedUrl = `${this.ENDPOINT}/${id}`;
                    this.openEditContinueModal();

                } else if (result.isDismissed) {
                }
            });
        },
        openEdit(id){
            this.selectedUrl = `${this.ENDPOINT}/${id}`;
            this.openAddEditModal();
        },
        openDelete(id){
            this.openDeleteModal();
        },
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },

        openEditContinueModal() {
            this.isEditContinueModalActive = true;
        },
        /**
         * for close add edit modal
         */
        closeAddEditModal() {
            let m_id = `#NEW_COURSE-form`;
            $(m_id).modal('hide');
            this.isAddEditModalActive = false;
            // this.searchAndSelectFilterOptions();
            this.reSetData();
        },

        closeEditContinueModal() {
            let m_id = `#NEW_COURSE-form-continue`;
            $(m_id).modal('hide');
            this.isEditContinueModalActive = false;
            // this.searchAndSelectFilterOptions();
            this.reSetData();
        },
        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj, active) {
            this.rowData = rowData;

            if (actionObj.title == 'Delete') {
                this.openDeleteModal();
            } else if (actionObj.title == this.$t('edit')) {
                this.selectedUrl = `${this.ENDPOINT}/${rowData.id}`;
                this.openAddEditModal();
            } else if (actionObj.title == 'Continue') {
                Swal.fire({
                title: 'Confirmation',
                html: `Continue Class ${rowData.course_name} `,
                icon: 'question',
                showCancelButton: true,
                showDenyButton: true,
                confirmButtonText: 'Continue',
                denyButtonText: 'Edit',
                cancelButtonText: 'Cancel',
                denyButtonColor: '#46c35f',
                }).then((result) => {
                if (result.isConfirmed) {
                    
                    Swal.fire({
                        title: "",
                        text: "Are you sure you want to confirm this class for the next semester?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Ok",
                        cancelButtonText: "Cancel",
                        reverseButtons: true,
                    }).then((result) => {
                        if (result.isConfirmed) {

                            Swal.close();

                            Swal.fire({
                                title: 'Processing...',
                                allowOutsideClick: false,
                                showConfirmButton: false,
                                didOpen: () => Swal.showLoading()
                            });

                            this.axiosPatch({
                                url: `/transaction/new-course-continue-next-semester/${rowData.id}`,
                            })
                            .then((response) => {
                                Swal.close();

                                if (response.data.status === true) {
                                    Swal.fire({
                                        title: "Success",
                                        text: "Class successfully continued to the next semester.",
                                        icon: "success",
                                    }).then(() => {
                                        this.reloadTable();
                                    });
                                } else {
                               
                                    Swal.fire({
                                        title: "Failed",
                                        text: response.data.message,
                                        icon: "error",
                                    });
                                }
                            })
                            .catch((error) => {
                                Swal.close();

                                const message = error.response?.data?.message || error.message || "Something went wrong";

                                Swal.fire({
                                    title: "Failed",
                                    text: message,
                                    icon: "error",
                                });
                            });
                        }
                    });
                    
                } else if (result.isDenied) {

                    this.selectedUrl = `${this.ENDPOINT}/${rowData.id}`;
                    this.openEditContinueModal();

                } else if (result.isDismissed) {
                }
                });
            }
        },

        /**
         * for open confirmation modal
         */
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        // searchAndSelectFilterOptions() {
        //     this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then(response => {
        //         let name = this.options.filters.find(element => element.title === this.$t('search_and_select'));

        //         name.option = response.data.map(name => {
        //             return {
        //                 id: name.name,
        //                 value: name.name
        //             }
        //         });
        //     });
        // },

        exportAll() {
            window.location.replace(urlGenerator(DATATABLE_EXPORT))
        },
        reloadTable() {
            this.$hub.$emit("reload-" + this.tableId);
            // this.resetSelection();
        },
    },
}
</script>

<style scoped>
	::v-deep(.datatable-th) {
		z-index: 10;
		position: relative;
	}
	::v-deep(.pt-primary ) {
		padding-top: 0 !important;
	}
</style>